

export const index = 6;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/schwerpunkte/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/6.CVl7AGuO.js","_app/immutable/chunks/DowcGjab.js","_app/immutable/chunks/BzCi4Of2.js","_app/immutable/chunks/DuUomSZU.js"];
export const stylesheets = ["_app/immutable/assets/6.WrYbQpfD.css"];
export const fonts = [];
